// eslint-disable-next-line no-shadow
export enum Samplers {
	DPM_SDE = 'DPM++SDE',
	DPM_SDE_KARRAS = 'DPM++SDE Karras',
	DPM_2M = 'DPM++2M',
	DPM_2M_KARRAS = 'DPM++2M Karras',
	DPM_2S_A_KARRAS = 'DPM++2Sa Karras',
	EULER = 'Euler',
	EULER_A = 'Eulera',
	DPM2 = 'DPM2',
	DPM2_Karras = 'DPM2 Karras',
	DPM_2M_SDE = 'DPM++2MSDE',
	DPM_2M_SDE_Karras = 'DPM++2MSDE Karras',
	LMS = 'LMS',
	Heun = 'Heun',
	DDIM = 'DDIM',
	PLMS = 'PLMS',
}
